import React, { FunctionComponent } from 'react';

import { parsePrice } from '../../../utils/utils';

const Summary: FunctionComponent<{ amount: number; internetCharges: number }> = ({ amount, internetCharges }) => (
  <div className="mt5 summary bg-white mb16">
    <div className="flex justify-content-s">
      <span>Payable Amount</span>
      <span className="fwb">{parsePrice({ price: amount + internetCharges })}</span>
    </div>
    <div className="flex justify-content-s mt11">
      <span className="smaller">Total Amount</span>
      <span className="smaller">{parsePrice({ price: amount })}</span>
    </div>
    <div className="flex justify-content-s mt8">
      <span className="smaller">Internet Handling Charges </span>

      <span className="smaller">{parsePrice({ price: internetCharges })}</span>
    </div>
  </div>
);

export default Summary;
